import { defineComponent } from 'vue';
import BasicButton from './BasicButton.jsx';
import utils from '../../Shared/utils.jsx';
import { normalizeIconName } from '../../Shared/buttonAppearance.js';

export default defineComponent({
    name: 'wizard-button',
    extends: BasicButton,
    data() {
        return {
            typeEval: null,
            iconEvalWizard: null,
            iconPositionEvalWizard: null,
            buttonTextEval: null,
        };
    },
    computed: {
        buttonType() {
            try {
                if (this.typeEval === null && this.controlData.Type)
                    this.typeEval = utils.compile(this, this.controlData.Type);
                if (this.typeEval)
                    return utils.evaluate(this.typeEval, this);
                return 'Next';
            } catch (e) {
                utils.warn('Type could not evaluate expression: ' + this.controlData.Type + '; ' + e);
                return 'Next';
            }
        },
        text() {
            try {
                if (this.buttonType === 'Next' || this.buttonType === 'Back' || this.buttonType === 'Finish')
                    return this.buttonType;
                if (this.buttonTextEval === null && this.controlData.Text)
                    this.buttonTextEval = utils.compile(this, this.Translate(this.controlData.Text));
                if (this.buttonTextEval)
                    return utils.evaluate(this.buttonTextEval, this);
                return 'Next';
            } catch (e) {
                utils.warn('Text could not evaluate expression: ' + this.controlData.Text + '; ' + e);
                return 'Next';
            }
        },
        icon() {
            try {
                if (this.iconEvalWizard === null && this.controlData.Icon)
                    this.iconEvalWizard = utils.compile(this, this.controlData.Icon);
                if (this.iconEvalWizard) {
                    const icon = utils.evaluate(this.iconEvalWizard, this);
                    return normalizeIconName(icon, { iconStyle: this.controlData.IconStyle });
                }
                if (this.buttonType === 'Back')
                    return 'mdi-chevron-double-left';
                if (this.buttonType === 'Next')
                    return 'mdi-chevron-double-right';
                return '';
            } catch (e) {
                utils.warn('Icon could not evaluate expression: ' + this.controlData.Icon + '; ' + e);
                return 'mdi-chevron-double-right';
            }
        },
        iconPosition() {
            try {
                if (this.buttonType === 'Next')
                    return 'Right';
                if (this.buttonType === 'Back')
                    return 'Left';
                if (this.iconPositionEvalWizard === null && this.controlData.IconPosition)
                    this.iconPositionEvalWizard = utils.compile(this, this.controlData.IconPosition);
                if (this.iconPositionEvalWizard)
                    return utils.evaluate(this.iconPositionEvalWizard, this);
                return 'Right';
            } catch (e) {
                utils.warn('IconPosition could not evaluate expression: ' + this.controlData.IconPosition + '; ' + e);
                return 'Right';
            }
        },
        color() {
            try {
                let theColor = 'primary';
                if (this.colorEval === null && this.controlData.Color)
                    this.colorEval = utils.compile(this, this.controlData.Color);
                if (this.colorEval)
                    theColor = utils.evaluate(this.colorEval, this);

                if (this.variant === 'outlined' && theColor)
                    theColor = theColor.replace('outline-', '');
                else
                    theColor = theColor || 'secondary';

                if (theColor === 'default')
                    return 'secondary';
                if (theColor === 'danger')
                    return 'error';
                return theColor;
            } catch (e) {
                utils.warn('color could not evaluate expression: ' + this.controlData.Color + '; ' + e);
                return 'secondary';
            }
        },
        variant() {
            if (!this.controlData.Color && this.buttonType !== 'Next' && this.buttonType !== 'Finish')
                return 'outlined';
            if (this.controlData.Themes && this.controlData.Themes.includes('Flat'))
                return 'text';
            if (this.controlData.Themes && this.controlData.Themes.includes('Transparent'))
                return 'plain';
            if (this.controlData.Color && this.controlData.Color.includes('outline-'))
                return 'outlined';
            if (this.controlData.Themes && this.controlData.Themes.includes('CondensedBordered'))
                return 'outlined';
            return 'flat';
        },
    },
    methods: {
        async doClick(e) {
            e.cancelBubble = true;
            if (this.stopPropagation)
                e.stopPropagation();

            const wizard = this.ParentByType('Wizard');
            if ((!this.controlData.Actions || !this.controlData.Actions.length) && wizard) {
                switch (this.buttonType) {
                    case 'Back':
                        wizard.PreviousStep();
                        break;
                    case 'Next':
                        wizard.NextStep();
                        break;
                    default:
                        break;
                }
                return;
            }

            await utils.executeAndCompileAllActions(this.controlData.Actions, null, this);
        },
    },
});